import React from 'react';
// images
import motherHoldingChild from  '../../../../../images/components/experienceCalloutImages/mother-holding-her-child.webp';
// styles
import { ExperienceCalloutStyled } from './styles';

export default () => (
  <ExperienceCalloutStyled
    assistiveText='Use our Life Insurance calculator to see how much life insurance is right for you.'
    isFullWidth
    withBGImage
    sectionId='quiz-callout-universal-life-insurance'
    imageUrl={motherHoldingChild.toString()}
    headingText='How much do you know about life insurance&#63;'
    buttonText='Take our quiz'
    linkUrl='/life-and-money/quiz/life-insurance-quiz-how-much-do-you-know/'
    withHoverShadow={false}
    moduleName='quiz-callout-module'
    moduleVariation='A'
    backgroundVariant='darkDefault'
    calloutBackgroundVariant='darkDefault'
    calloutThemeType='darkTheme'
    themeType='darkTheme'
    disableLazyLoad
  />
);
